export default () => ({
  alwaysEnabled: [
    'beginner',
    'desserts',
    'soups',
  ],

  init() {
    this.store = Alpine.store("data")
  },

  isMealEnabled(mealType) {
    if (this.alwaysEnabled.includes(mealType)) return true

    const favIngredients = this.store.values.favIngredients
    const preferredProtein = this.store.values.preferredProtein

    // Conditions based on product requirements.
    // String values hardcoded as there is no other option in current stack
    switch (mealType) {
      case 'eggs':
        return favIngredients.includes('eggs') ||
          preferredProtein.includes('eggs')
      case 'salads':
        return favIngredients.includes('avocado') ||
          favIngredients.includes('nuts') ||
          favIngredients.includes('beans')
      case 'chicken':
        return preferredProtein.includes('chicken')
      case 'beef':
        return preferredProtein.includes('beef')
      case 'beginner':
      case 'desserts':
      case 'soups':
      case 'vegetarian':
        return favIngredients.includes('tofu') ||
          favIngredients.includes('mushrooms') ||
          preferredProtein.includes('plant')
      case 'fish':
        return preferredProtein.includes('fish')
      case 'lamb':
        return preferredProtein.includes('lamb')

      default:
        break;
    }
  },
})
